<rr-start-logo class="logo" color="inverse" routerLink="/"></rr-start-logo>
<div class="card col">
    <img src="/images/congrat-signup.png" alt="" />
    <h1 i18n>You're almost there!</h1>
    <div>
        We've sent a confirmation link to your email. Just click it to activate
        your account — it only takes a second.<br /><br />
        <h4>E-Mail not found? Please also check your Spam folder.</h4>
    </div>
</div>
